import { centerable as i } from "../decorators/centerable.js";
import { stylable as b } from "../decorators/stylable.js";
import { BLOCK_CLASSES as l } from "../../constants.js";
import u from "../../bundled_deps/.pnpm/tinycolor2@1.6.0/bundled_deps/tinycolor2/esm/tinycolor.js";
import { defineAttrs as f } from "../../utils/typed-attrs.js";
import { getBackgroundColor as g } from "./spec-util.js";
const s = (t) => {
  var e, n;
  const r = t.querySelector("a");
  let o = (e = r == null ? void 0 : r.style) == null ? void 0 : e.backgroundColor;
  return o === "transparent" && (o = (n = r == null ? void 0 : r.style) == null ? void 0 : n.borderColor), o ? g(o) : "";
}, d = (t) => u(t).isValid() ? u(t).getLuminance() > 0.179 ? "color: #000000;" : "color: #ffffff;" : "", y = (t) => {
  var r, o;
  return t.attrs.buttonStyle === "outline" ? `border-color: ${(r = t.attrs) == null ? void 0 : r.backgroundColor}; background-color: transparent; border-style: solid;` : `border-color: transparent; background-color: ${(o = t.attrs) == null ? void 0 : o.backgroundColor}; border-style: solid;`;
};
function c(t) {
  var r, o;
  return ((o = (r = t.querySelector("a")) == null ? void 0 : r.style) == null ? void 0 : o.backgroundColor) === "transparent" ? "outline" : "solid";
}
const k = f({
  type: { default: "button" },
  linkUrl: { default: "" },
  text: { default: "" },
  buttonStyle: { default: "solid" }
}), x = b(
  i({
    inline: !1,
    attrs: k,
    group: "block",
    parseDOM: [
      {
        tag: `div.${l.button}`,
        getAttrs(t) {
          return {
            linkUrl: t.getAttribute("data-link-url"),
            text: t.textContent,
            backgroundColor: s(t),
            buttonStyle: c(t)
          };
        }
      },
      {
        tag: "div.intercom-interblocks-button",
        getAttrs(t) {
          const r = t.querySelector("a");
          return {
            linkUrl: r == null ? void 0 : r.getAttribute("href"),
            text: t.textContent,
            backgroundColor: s(t),
            buttonStyle: c(t)
          };
        }
      }
    ],
    toDOM(t) {
      const r = t.attrs;
      let { text: o } = r;
      const { fontColor: e } = r;
      o ?? (o = "Enter button text");
      const n = e ? `color: ${e};` : d(r.backgroundColor), a = y(t);
      return [
        "div",
        {
          class: `${l.blockContainer} ${l.button}`,
          "data-link-url": r.linkUrl
        },
        [
          "a",
          {
            class: "intercom-h2b-button",
            style: `${a} ${n} `
          },
          o
        ]
      ];
    }
  })
);
export {
  x as buttonSpec,
  s as getButtonBackgroundColor
};
